import { Linking, Pressable, ScrollView, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { isWeb } from '@/constants/app'
import { marketPresentation } from '@/config/marketPresentation'
import { cn } from '@/utils/cn'
import { ChevronRight } from '@/components/icon'
import { Stack } from '@/components/layout'
import NavigationBar from '@/components/NavigationBar'
import SectionHeader from '@/components/SectionHeader'

export default function NotificationScreen() {
  const { t, i18n } = useTranslation()
  const items = [
    { label: t('ui:language'), status: t(`ui:languageName.${i18n.resolvedLanguage ?? i18n.language}`) },
    { label: t('ui:pricingCurrency'), status: marketPresentation.localFiat.code }
  ]

  return (
    <>
      <Stack.Screen
        options={{
          header: () => <NavigationBar hasBottomBorder={true}>{t('ui:settings')}</NavigationBar>
        }}
      />
      <ScrollView className={'flex-1'} contentContainerStyle={{ paddingBottom: 16 }}>
        <View className={'bg-background-secondary'}>
          {!isWeb && (
            <>
              <SectionHeader>{t('ui:appNotifications')}</SectionHeader>
              <Pressable onPress={() => Linking.openSettings()}>
                {({ pressed }) => (
                  <View
                    className={cn(
                      'h-[84px] justify-center border-y border-border-10 bg-background-primary px-4',
                      pressed && 'bg-background-secondary'
                    )}
                  >
                    <View className={'flex-row justify-between gap-2'}>
                      <View className={'grow basis-0 gap-1'}>
                        <Text className={'text-base text-text-primary'}>{t('ui:devicePermissions')}</Text>
                        <View>
                          <Text className={'text-xs text-text-secondary'}>
                            {t('ui:notificationPermissionDescription')}
                          </Text>
                        </View>
                      </View>
                      <View className={'flex-row items-center gap-2'}>
                        <Text className={'text-base text-text-tertiary'}>{t('ui:enabled')}</Text>
                        <ChevronRight className={'size-6 text-text-tertiary'} />
                      </View>
                    </View>
                  </View>
                )}
              </Pressable>
            </>
          )}
          <SectionHeader>{t('ui:general')}</SectionHeader>
          {items.map((item, index) => (
            <View className={cn('bg-background-primary', index === 0 && 'border-t border-border-10')} key={index}>
              <View
                className={cn(
                  'h-12 flex-row items-center border-b border-border-10 pr-4',
                  index === items.length - 1 ? 'pl-4' : 'ml-4'
                )}
              >
                <Text className={'flex-1 text-base text-text-primary'}>{item.label}</Text>
                <View className={'flex-row items-center gap-x-2'}>
                  <Text className={'text-base text-text-tertiary'}>{item.status}</Text>
                </View>
              </View>
            </View>
          ))}
          {/* <View className={'mt-6 px-4'}>
            <Button intent={'neutral'} variant={'outline'} size={'md'} onPress={() => console.log('log out')}>
              {t('profile:logout')}
            </Button>
          </View> */}
        </View>
      </ScrollView>
    </>
  )
}
